import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import UserService from '../../services/UserService';
import moment from "moment";
import { showLoading } from 'react-global-loading';
import CountryHeader from "./CountryHeader";

export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';

const CountryCenters = (props) => {
  const [countryId, setCountryId] = useState(props.match.params.id);
  const [categoryId, setCategoryId] = useState(props.match.params.catId);
  const [centerData, setDocument] = useState();
  const [documentsList, setDocumentsList] = useState([]);

  useEffect(() => {
    showLoading(false);
    getCenterList();
  }, []);

  const getCenterList = () => {
    UserService.getAllCenters({ 'blog_id': countryId, 'category': categoryId })
      .then((result) => {
        if (!result) {
          return;
        }
        setDocumentsList(result);
        showLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleCallback = (childData) => {

    setCategoryId(childData.id)
  };
  return (
    <div className="container pt-2">
      <CountryHeader parentCallback={handleCallback} category={categoryId} country={countryId} />
      <div className="row bg-light p-2 pt-4 mt-5 mb-3 rounded rounded-2">
        <div className="col-12">
          <h3 className="mb-3">Centers</h3>
          <div className="row view-group" id="Documents2">
            {/* below is the Document card */}
            {documentsList.length > 0 ? documentsList.map((item, index) =>
              <div key={index} className="col-md-3 mb-3" data-bs-toggle="modal"
                data-bs-target="#docModal" onClick={() => setDocument(item)}>
                <div className="card p-3 event-card crdev">
                  <div className="imgrel">
                    {/* <Link to={{
                      pathname: "/document-details",
                      search: `?id=${item.ID}`,
                      state: { DocumentDetails: item }
                    }}> */}
                    <img src={require('../../public/pdf_view-all.png')} className=" card-img-top rounded" alt="events" style={{ width: '50px', objectFit: 'cover' }} />
                    {/* </Link> */}
                  </div>
                  <div className="evtxcn px-0">
                    <h4 className="evh">
                      <Link to={"/document-details?id=" + item.ID} className="evhd crop-text">{item.centerName}</Link>
                    </h4>
                    <span className="muted d-block mt-1 doccell crop-text">{item.centerName}</span>
                    <p className="evdes_nw">{item.physicianName}</p>
                  </div>
                </div>
              </div>
            ) : <div className="col-12 mb-4">
              <div class="alert alert-success" role="alert">
                <h4 class="alert-heading">
                  <i class="fa fa-exclamation-circle me-1" aria-hidden="true"></i> Data Not Found!
                </h4>
                <p>We regret to inform you that the requested data could not be located or does not exist in our records. It is possible that the information you are seeking has not been documented, is not publicly available, or has been removed or archived.</p>
              </div>
            </div>
            }
          </div>
        </div>
        <div
          className="modal fade"
          id="docModal"
          tabIndex="-1"
          aria-labelledby="docapprovalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">

            <div className="modal-content bg-white p-3">


              <div className="modal-body">
                <div className="row mt-4">
                  <div className="col-md-6">
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="practitionername" id="physicianname" className="form-label over-label">Head Physician’s Name*</label>
                      <input disabled type="text" aria-labelledby="physicianname" className="form-control pd-tb-675em" placeholder="Enter your center name Head Physician’s Name" name="practitionername" value={centerData?.physicianName} />
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="clinicname" id="centername" className="form-label over-label">Center’s Name*</label>
                      <input disabled type="text" aria-labelledby="centername" className="form-control pd-tb-675em" placeholder="Enter your Center’s Name" name="clinicname" value={centerData?.centerName} />
                    </div>

                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="eventnamee" id="subdomains" className="form-label"><b>Domains*:</b></label>
                      <div className="btn-group d-block   chbcn" role="group" aria-label="Basic checkbox toggle button group">
                        {centerData?.selectedCategory.map((item, index) =>
                          <label className="  btn-outline-dark " >{item}</label>
                        )}
                      </div>
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="eventnamee" id="subdomains" className="form-label"><b>Services*:</b></label>

                      {centerData?.centerServices?.map((item, index) => <li key={index} className="list-group-item d-flex justify-content-between align-items-center">{item}
                      </li>)}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="mailid" id="contactid" className="form-label over-label">E-mail Id*</label>
                      <input disabled type="email" aria-labelledby="contactid" className="form-control inpd" name="mailid" value={centerData?.centerEmail} />
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="statename" id="statetitle" className="form-label over-label">State</label>
                      <input disabled type="text" aria-labelledby="statetitle" className="form-control inpd" name="pincode" value={centerData?.selectedState} />

                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="cityname" id="citytitle" className="form-label over-label">City</label>
                      <input disabled type="text" aria-labelledby="citytitle" className="form-control inpd" name="pincode" value={centerData?.selectedCity} />
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="pincode" id="pincodenumber" className="form-label over-label">Pin Code</label>
                      <input disabled type="number" aria-labelledby="pincodenumber" className="form-control inpd" name="pincode" value={centerData?.pincode} />
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="centeraddress" id="addcenteraddress" className="form-label over-label">Center’s Address</label>
                      <textarea aria-labelledby="addcenteraddress" disabled className="form-control textarea-height" name="centeraddress" rows="4" value={centerData?.centerAddress}></textarea>
                    </div>
                    <div className="form-group mb-4 position-relative">
                      <label htmlFor="contactnumber" id="phonenumber" className="form-label over-label">Contact Number</label>
                      <input disabled type="number" aria-labelledby="phonenumber" className="form-control inpd" name="contactnumber" value={centerData?.contact} />
                    </div>

                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-md-8">

                    <ul className="list-group search-list mt-3">
                      {/* {centerData?.centerServices?.map((item, index) => <li key={index} className="list-group-item d-flex justify-content-between align-items-center">{item}
                      </li>)} */}

                    </ul>
                  </div>


                </div>
              </div><div className="modal-footer">
                <button type="button" className="btn theme-btn-outline" data-bs-dismiss="modal" id="closeCenterButton" >Close</button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryCenters;
